import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const RegisterPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-3 md:space-y-4">
      <div className="h-px bg-border"></div>
      <p className="text-sm md:text-base text-muted-foreground">
        Don't have an account?{' '}
        <button
          onClick={() => navigate('/register')}
          className="text-primary hover:text-primary/80 font-semibold transition-colors duration-250"
        >
          Create Account
        </button>
      </p>
      <Button
        variant="outline"
        fullWidth
        onClick={() => navigate('/register')}
        iconName="UserPlus"
        iconPosition="left"
      >
        Sign Up for Free
      </Button>
    </div>
  );
};

export default RegisterPrompt;